module.exports = __webpack_public_path__ + "static/media/26.cd6beb2c.jpg";